/**
* @file 运营中心-旅游包车订单
* */
<template>
  <div id="order">
    <custom-table style="height: 100%" ref="customTable" labelWidth="135" :has-organization="false"
      :customOptions="customOptions" :columns="columns" excel-type="HitchRideOrderHistory" :columnsSettingShow="true">
      <template slot="table-operation">
        <el-table-column label="操作" width="80" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="showOrderDetail(row)">详情</el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{
          row.created | filterTime
        }}</template>
        <template v-else-if="
          [
            'latestDepartureTime',
            'created',
            'finishTime',
          ].includes(item.prop)
        ">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop == 'orderNo'">
          <span class="order-no-link" @click="showOrderDetail(row)" @dblclick="$utils.dblclickCopy">{{ row.orderNo }}</span>
          <div style="margin-top: 4px;">
            <el-tag type="primary" size="mini" v-if="row.status == 10">新订单</el-tag>
            <el-tag type="success" size="mini" v-else-if="row.status > 10 && row.status < 100">已接单</el-tag>
            <el-tag type="info" size="mini" v-else>已取消</el-tag>
          </div>
        </template>
        <template v-else-if="item.prop == 'partnerOrderId'">
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] :
            "-" }}</span>
        </template>

        <template v-else-if="item.prop === 'startCity'">
          <div>{{ row.startCity }} - {{ row.endCity }}</div>
          <el-tag :type="row.cityType == 1 ? 'warning' : 'success'" size="small">{{ row.cityType == 1 ? '城际' : '市内' }}线路</el-tag>
        </template>
        <template v-else-if="item.prop == 'earliestDepartureTime'">
          <span>{{ row.earliestDepartureTime | filterTime }}</span>
          <div style="color: #999">{{ row.latestDepartureTime | filterTime }}</div>
        </template>
        <template v-else-if="item.prop === 'startPointName'">
          <div>{{ row.startPointName }}</div>
          <div style="color: #999">{{ row.startPointAddress }}</div>
        </template>
        <template v-else-if="item.prop === 'endPointName'">
          <div>{{ row.endPointName }}</div>
          <div style="color: #999">{{ row.endPointAddress }}</div>
        </template>
        <template v-else-if="item.prop == 'poolType'">
          <el-tag :type="row.poolType == 1 ? 'primary' : 'success'" size="small">{{ row.poolType == 1 ? '独享' : '拼车' }}</el-tag>
        </template>
        <template v-else-if="item.prop == 'channelAlias'">
          {{ row.channelAlias | filterConst("HITCHHIKINGCHANNEL") }}
        </template>

        <template v-else-if="item.prop == 'vehicleSeat'">{{ row.vehicleSeat }}座</template>
        <template v-else-if="item.prop == 'distance'">
          <span>{{ row.distance }} km</span>
          <div style="color: #2B77FF">{{ ((row.amount / row.distance) || 0).toFixed(2) }} 元/公里</div>
        </template>
        <template v-else-if="item.prop == 'realPhoneSuffix'">用户{{ row.realPhoneSuffix }} / {{ row.passengerNum
        }}人</template>

        <template v-else-if="item.prop == 'cancelFee'">
          <span v-if="row.cancelFee">
            <span class="util-money">¥{{ row.cancelFee || 0 }}</span><span v-if="row.cancelRatio">({{ row.cancelRatio
            }}取消费率)</span>
          </span>
          <span v-else>-</span>
        </template>

        <template v-else-if="item.prop == 'amount'">
          <span class="util-money"> ¥{{ row.amount || 0 }} </span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <!-- 订单详情抽屉 -->
    <order-detail-drawer :show.sync="orderDetailVisible" :order="currentOrderDetail" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderDetailDrawer from "@/components/orderDetailDrawer/orderDetailDrawer.vue";
export default {
  name: "hitchRideOrderHistory",
  components: {
    OrderDetailDrawer
  },
  data() {
    return {
      // 订单详情抽屉
      orderDetailVisible: false,
      currentOrderDetail: {},
      // 表头
      columns: [
        { prop: "orderNo", label: "订单号", minWidth: 190 },
        { prop: "startCity", label: "城市/线路", minWidth: 120 },
        { prop: "startPointName", label: "上车位置", minWidth: 200 },
        { prop: "endPointName", label: "下车位置", minWidth: 200 },
        { prop: "earliestDepartureTime", label: "出发时间", minWidth:140 },
        { prop: "realPhoneSuffix", label: "乘客", minWidth: 120 },
        { prop: "poolType", label: "是否拼车", minWidth: 80 },
        { prop: "amount", label: "订单金额", minWidth: 100 },
        { prop: "distance", label: "计价里程", minWidth: 100 },
        { prop: "reason", label: "取消原因", minWidth: 100 },
        { prop: "partnerOrderId", label: "三方订单号", minWidth: 120 },
        { prop: "created", label: "下单时间", minWidth: 140 },
      ]
    };
  },
  computed: {
    ...mapGetters({
      cityList: "allCityListGetter",
    }),
    // 配置项
    customOptions() {
      return {
        // 请求的列表url
        url: "/api/v1/manage/order/hitchRide/history",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "hitchRideOrderStatus",
            name: "订单状态",
            value: "",
            option: this.$const.HITCHHIKINGSTATUS,
          },
          {
            type: "select",
            field: "startCityCode",
            name: "发单城市",
            value: "",
            option: this.cityList,
            filterable: true,
          },
          {
            type: "select",
            field: "cityType",
            name: "线路类型",
            value: "",
            option: this.$const.HITCHHIKINGTYPE,
          },
          {
            type: "select",
            field: "poolType",
            name: "订单类型",
            value: "",
            option: this.$const.POOLTYPE,
          },
          // {
          //   type: "datetime",
          //   field: "Time",
          //   dateProp: { start: "startTime", end: "endTime" },
          //   name: "下单时间",
          //   value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)], 
          //   defaultDays: 30
          // },
          { type: "datetime", 
          field: "time", 
          name: "下单时间", 
          value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)], 
          defaultDays: 30},
        ],
      }
    },
  },
  created() {

  },
  async mounted() {},
  methods: {
    /**
     * 显示订单详情
     */
    showOrderDetail(row) {
      this.currentOrderDetail = { ...row };
      this.orderDetailVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
#order {
  .order-no-link {
    color: #2B77FF;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
